/**
 * Inbounds.jsx — Aba "Inbounds" do DetailPanel.
 *
 * Lista de entradas (ordens de compra/recebimento) vinculadas ao SKU. Fetch
 * lazy via Context (inboundsState).
 */

import { useDetailPanel } from '../index.jsx';
import { FormatDate, Pager, StatusMsg } from '../internals.jsx';

export function Inbounds() {
    const { T, tab, inboundsState: state, inPage, inPageSize, setInPage, setInPageSize } = useDetailPanel();
    if (tab !== 'inbounds') return null;

    if (state.loading) {
        return <StatusMsg T={T}>Carregando…</StatusMsg>;
    }
    if (state.error) {
        return (
            <StatusMsg kind="error" T={T}>
                {state.error}
            </StatusMsg>
        );
    }
    const rows = Array.isArray(state.data?.results) ? state.data.results : [];
    const total = Number(state.data?.paging?.total ?? rows.length);
    if (rows.length === 0) {
        return <StatusMsg T={T}>Nenhum inbound vinculado a este SKU.</StatusMsg>;
    }
    return (
        <div>
            <div style={{ border: `1px solid ${T.line}`, borderRadius: 4, overflow: 'hidden' }}>
                {rows.map((r, i) => (
                    <div
                        key={r.id || r.purchase_order_id || `${r.code || 'in'}-${i}`}
                        style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 100px 80px 130px',
                            padding: '8px 12px',
                            fontSize: 12,
                            borderBottom: i < rows.length - 1 ? `1px solid ${T.line}` : 'none',
                            background: i % 2 === 0 ? T.bg : T.bgSoft,
                            gap: 8,
                            alignItems: 'center',
                        }}
                    >
                        <span
                            style={{
                                fontFamily: T.mono,
                                color: T.ink,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }}
                        >
                            {r.code || r.purchase_order_id || r.id || '—'}
                        </span>
                        <span style={{ color: T.inkMid }}>{r.status || '—'}</span>
                        <span style={{ fontFamily: T.mono, color: T.ink, textAlign: 'right' }}>
                            {Number(r.units || r.expected_units || 0)} un
                        </span>
                        <span style={{ color: T.muted, fontSize: 11 }}>
                            {FormatDate(r.expected_at || r.requested_at || r.created_at)}
                        </span>
                    </div>
                ))}
            </div>
            <Pager
                total={total}
                page={inPage}
                pageSize={inPageSize}
                onPageChange={setInPage}
                onPageSizeChange={setInPageSize}
                T={T}
            />
        </div>
    );
}
